export default __webpack_public_path__ + "static/media/and-the-war-came.f78670c1.jpg";